import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '24px',
      backgroundColor: '#f9fafb'
    }}>
      <h1 style={{ fontSize: '96px', fontWeight: 700, color: '#3b82f6', marginBottom: '16px' }}>
        404
      </h1>
      <h2 style={{ fontSize: '24px', fontWeight: 600, color: '#111827', marginBottom: '8px' }}>
        Page Not Found
      </h2>
      <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '32px', textAlign: 'center' }}>
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/vault"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#3b82f6',
          color: '#ffffff',
          padding: '12px 24px',
          borderRadius: '8px',
          fontWeight: 600,
          textDecoration: 'none'
        }}
      >
        <Home size={20} />
        Go to Vault
      </Link>
    </div>
  );
}
